import {
  Card,
  CardHeader,
  CardPreview,
  Drawer,
  LabeledDivider,
} from "@verde/compose-ui";
import {
  type FetchFieldInsight,
  type Image,
  useDownloadImage,
} from "@verde/entities";
import {
  DashboardIcon,
  DownloadIcon,
  HomeIcon,
  SendIcon,
  UserIcon,
} from "@verde/icons";
import { Button, Link, Loader, Spinner, Text } from "@verde/ui-core";
import { useReducer, useState } from "react";
import CardDetails from "./CardDetails";

const NO_IMAGE =
  "https://stag-verde-s3.s3.us-west-2.amazonaws.com/ey9hz669kgfsmcvzgf4pdlfqvxbj";

export default function TemplateCard({ advise }: TemplateCardProps) {
  const [isOpenDrawer, toggleOpenDrawer] = useReducer((value) => !value, false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedInsight, setSelectedInsight] = useState<
    FetchFieldInsight | undefined
  >(undefined);
  const download = useDownloadImage();
  const hasImage = !!advise.image?.file_url;

  return (
    <Card size="sm">
      <p className="text-lg font-bold text-neutral-dark-3">{advise.title}</p>
      <div className="grid gap-3 rounded">
        <div className="grid bg-neutral-light-1 rounded-t p-3 pb-5 min-h-[373px]">
          <div className="relative ">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center z-10">
                {<Loader className="place-self-center" />}
              </div>
            )}

            <img
              src={advise.image.file_url || NO_IMAGE}
              alt=""
              onLoad={() => setIsLoading(false)}
              onError={() => setIsLoading(false)}
              onClick={() => {
                advise.image.file_url &&
                  window.open(advise.image.file_url, "_blank");
              }}
              className={` rounded-t border border-neutral-light-2 hover:scale-105 transition-all duration-500  cursor-pointer ${
                isLoading ? "opacity-0" : "opacity-100"
              }`}
            />
          </div>
        </div>
        <div className="bg-neutral-light-1 rounded-b p-3 gap-4">
          <p className="font-medium text-brand-green-dark">Recomendados:</p>
          <LabeledDivider classNames={{ base: "items-center" }}>
            <Text className="font-bold text-neutral-dark-3 text-xl ">
              Produtores ({advise.clients_count})
            </Text>
            <Link
              kind="secondary"
              size="lg"
              onClick={() => {
                setSelectedInsight(advise);
                toggleOpenDrawer();
              }}
            >
              <Text className="font-bold text-brand-green-default ">Ver</Text>
            </Link>
          </LabeledDivider>
        </div>
        <div className="grid gap-2">
          <Button disabled={!hasImage} icon={<SendIcon />} kind="primary">
            Receber no meu whatsapp
          </Button>
          <Button
            disabled={!hasImage}
            kind="secondary"
            onClick={async () => await download.execute(advise?.image)}
            icon={<DownloadIcon />}
          >
            Fazer Download
          </Button>
        </div>
      </div>
      {isOpenDrawer && selectedInsight?.id && (
        <CardDetails
          insightId={selectedInsight.id}
          open={isOpenDrawer}
          onClose={() => {
            toggleOpenDrawer();
            setSelectedInsight(undefined);
          }}
        />
      )}
      {/* <Drawer
        open={isOpenDrawer}
        onClose={() => {
          toggleOpenDrawer();
          setSelectedInsight(undefined);
        }}
        header={{
          title: "Verde Push",
          icon: <SendIcon className="-rotate-45" />,
          description:
            "Veja quais os produtores que se encaixam neste modelo de marketing.",
        }}
        footer={{
          primary: {
            children: "Fechar",
            onClick: () => {
              toggleOpenDrawer();
              setSelectedInsight(undefined);
            },
          },
        }}
      >
        <div className="grid gap-6">
          <div className="grid bg-neutral-light-1 rounded p-4 ">
            <div className="grid rounded border-brand-yellow border p-3 gap-4">
              <CardHeader
                icon={<DashboardIcon />}
                title="Por que estes produtores foram selecionados?"
              />
              <Text className="text-neutral-dark-1 font-normal ">
                {selectedInsight?.description}
              </Text>
              <Text className="font-semibold text-neutral-dark-1">
                Aproveite para enviar um alô com nosso material informativo!
              </Text>
            </div>
          </div>
          <CardHeader
            title="Produtores"
            description="Produtores selecionados elegível para a campanha de marketing"
            icon={<HomeIcon />}
          />
          <div className="grid gap-3">
            {selectedInsight?.clients?.map((client) => {
              <CardPreview
                icon={<UserIcon />}
                title={client.name}
                description={`Whatsapp: ${client.phone_number}`}
              />;
            })}
          </div>
        </div>
      </Drawer> */}
    </Card>
  );
}

export interface TemplateCardProps {
  advise: FetchFieldInsight;
}
